// extracted by mini-css-extract-plugin
export default {"aboutSection":"about_aboutSection__VpSTj","aboutRow":"about_aboutRow__jwoVc","description":"about_description__hGa40","photo":"about_photo__jn8Om","skills":"about_skills__kHoOE"};